/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

const uneditableFields = [
    "title",
    "description",
    "banner_image"
];

/**
 * Checks if the given field name is editable
 * @param {string} name 
 * @returns 
 */
export function isUneditableField (name) {
    return uneditableFields.includes(name);    
}
